import React, { Component } from 'react';
import navigation from '../navigation';



class MobileNav extends Component {
	constructor(props) {
		super(props);
		this.state= {
			index: "Home"
		}
	}


	componentWillReceiveProps(nextProps) {
		// console.log(nextProps)
	}

	componentDidMount() {
		let locationContent = navigation.find(content => {
			return content.navTitle === this.state.index
		})
		console.log(locationContent)
		this.props.getLocationContent(locationContent)
	}
	

	componentWillUpdate(nextProps, nextState) {
		// console.log(nextState)
		let nextFilter = navigation.filter(item => {
			return item.navTitle === nextState.index
		})
		

		if(this.state !== nextState) {

			let { mobileProgression, jumpToZoomMobile, mobileCoordinates } = nextFilter[0];
			// console.log(nextFilter[0])
			this.props.closeDetail();
			this.props.getNavContent(nextFilter[0]);
			this.props.jumpTo(mobileCoordinates, jumpToZoomMobile);
			this.props.getLocationContent(nextFilter[0])
		}
	}

	buttonProgression =(nextFilter) =>{
		

		let nextButton = nextFilter.map((item,i) => {
			let { mobileProgression, jumpToZoom, mobileCoordinates } = item;
			return(
				<div
					key={i} 
					className="MobileNav__button"
					onClick={(e)=>{
						
						
						this.changeProgression(item);
						this.props.closeDetail();
					}}>
					CHECK OUT {item.mobileProgression}
				</div>
			)
		});
		return nextButton;
	}

	changeProgression = (nextLocation) => {

		let { mobileProgression } = nextLocation;
		this.setState({
			index: nextLocation.mobileProgression,
			navContent: nextLocation
		})

	}

	render() {

		let nextFilter = navigation.filter(item => {
			return item.navTitle === this.state.index
		})

		this.buttonProgression(nextFilter)

		return(
			<div className="MobileNav">
				{this.buttonProgression(nextFilter)}
			</div>
		)
	}
}

export default MobileNav;


// WEBPACK FOOTER //
// ./src/components/MobileNav.js